import { Body, Controller, Get, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { CollectionsService } from "./collections.service";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import {CollectionIdRequest, CollectionsReq, DdbCollectionsReq, IgstCollectionsReq, IgstReportReq} from 'libs/shared-models/finance/src/lib/collections-req'
import { AgingReq,BrcReq, CollectionsFilters, DutyDrawBackDateReq, DutyDrawBackReportReq, PayableRequest, PaymentTypeReq, ReceivablesDetailsReq, ReceivablesSummaryReq, RmDateReq, RodtepReportReq, SaleReceiveReq, SaleReq, ScriptGenReq, iceGateReq, iceGateVerification,PayableFilterRequest, RmInvoiceDataForPayablesReq, RmPayblesReq } from "libs/shared-models/finance/src";
import { ProductionLogRequest } from "libs/shared-models/production-management/src/lib/production-inv/production-log.req";
import { IdRequest } from "@gtpl/shared-models/gtpl";
import { PayablesDashboardReq } from "@gtpl/shared-models/raw-material-procurement";


@ApiTags('/collections')
@Controller('/collections')
 export class CollectionsController{
    constructor(
        private service :CollectionsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){ }

    @Post('/getCollection')
    async getCollection(@Body() req:PaymentTypeReq): Promise<CommonResponse> {
        try {
            return await this.service.getCollection(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }   
    @Post('/generatePayment')
    async generatePayment(@Body() req:CollectionsReq): Promise<CommonResponse> {
        try {
            return await this.service.generatePayment(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/generateDdbPayment')
    async generateDdbPayment(@Body() req:DdbCollectionsReq): Promise<CommonResponse> {
        try {
            return await this.service.generateDdbPayment(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/getBuyers')
    async getBuyers(@Body() req:PaymentTypeReq): Promise<CommonResponse> {
        try {
            return await this.service.getBuyers(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }  
    @Post('/getReceivablesSummaryReport')
    async getReceivablesSummaryReport(@Body() req:ReceivablesSummaryReq): Promise<CommonResponse> {
        try {
            return await this.service.getReceivablesSummaryReport(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/getReceivablesDetailsReport')
    async getReceivablesDetailsReport(@Body() req:ReceivablesDetailsReq): Promise<CommonResponse> {
        try {
            return await this.service.getReceivablesDetailsReport(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getExportReceivablesData')
    async getExportReceivablesData(@Body() req:CollectionsFilters): Promise<CommonResponse>{
        try{
            return await this.service.getExportReceivablesData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getDutyDrawBackData')
    async getDutyDrawBackData(@Body() req:CollectionsFilters):Promise<CommonResponse>{
        try{
            return await this.service.getDutyDrawBackData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Get('/getBuyerSDropDown')
    async getBuyerSDropDown():Promise<CommonResponse>{
        try{
            return await this.service.getBuyerSDropDown();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Get('/getInvoiceNumber')
    async getInvoiceNumber():Promise<CommonResponse>{
        try{
            return await this.service.getInvoiceNumber();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getExpectedReceivablesReport')
    async getExpectedReceivablesReport():Promise<CommonResponse>{
        try{
            return await this.service.getExpectedReceivablesReport();
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getShippedPoData')
    async getShippedPoData(@Body()req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            return await this.service.getShippedPoData(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/iceGateUpdate')
    async iceGateUpdate(@Body()req:iceGateReq):Promise<CommonResponse>{
        try{
            return await this.service.iceGateUpdate(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getBrcPoData')
    async getBrcPoData(@Body()req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            return await this.service.getBrcPoData(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/brcUpdate')
    async brcUpdate(@Body()req:BrcReq):Promise<CommonResponse>{
        try{
            return await this.service.brcUpdate(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getScriptGenPoData')
    async getScriptGenPoData(@Body()req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            return await this.service.getScriptGenPoData(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getBrcInfo')
    async getBrcInfo(@Body() req:CollectionIdRequest):Promise<CommonResponse>{
        try{
            return await this.service.getBrcInfo(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/createScriptGeneration')
    async createScriptGeneration(@Body() req:ScriptGenReq):Promise<CommonResponse>{
        try{
            return await this.service.createScriptGeneration(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getLicsenseInfo')
    async getLicsenseInfo(@Body() req:CollectionIdRequest):Promise<CommonResponse>{
        try{
            return await this.service.getLicsenseInfo(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/createSale')
    async createSale(@Body() req:SaleReq):Promise<CommonResponse>{
        try{
            return await this.service.createSale(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getSalePoData')
    async getSalePoData():Promise<CommonResponse>{
        try{
            return await this.service.getSalePoData();
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getRodTepAbstractReport')
    async getRodTepAbstractReport(@Body() req?:ProductionLogRequest):Promise<CommonResponse>{
        try{
            return await this.service.getRodTepAbstractReport(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }


    @Post('/getRodtepReport')
    async getRodtepReport(@Body() req:RodtepReportReq):Promise<CommonResponse>{
        console.log(req,"reqqqqqqqqqqqqqqqqqq")
        try{
            return await this.service.getRodtepReportWithCollections(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getRodtepData')
    async getRodtepData(@Body() req:CollectionsFilters):Promise<CommonResponse>{
        try{
            return await this.service.getRodtepData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/iceGateVerification')
    async iceGateVerification(@Body() req:iceGateVerification):Promise<CommonResponse>{
        try{
            return await this.service.iceGateVerification(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getReceivePoData')
    async getReceivePoData(@Body()req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            return await this.service.getReceivePoData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/updateSaleReceived')
    async updateSaleReceived(@Body() req?:SaleReceiveReq):Promise<CommonResponse>{
        try{
            return await this.service.updateSaleReceived( req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getDutyDrawBackTotals')
    async getDutyDrawBackTotals(@Body() req:DutyDrawBackDateReq):Promise<CommonResponse>{
        try{
            return await this.service.getDutyDrawBackTotals(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getDutyDrawBackReport')
    async getDutyDrawBackReport(@Body() req:DutyDrawBackReportReq):Promise<CommonResponse>{
        try{
            return await this.service.getDutyDrawBackReport(req);
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getAllInvoiceNumber')
    async getAllInvoiceNumber():Promise<CommonResponse>{
        try{
            return await this.service.getAllInvoiceNumber();
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/generateIgstPayment')
    async generateIgstPayment(@Body() req:IgstCollectionsReq): Promise<CommonResponse> {
        try {
            return await this.service.generateIgstPayment(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/getIgstData')
    async getIgstData(@Body() req:CollectionsFilters):Promise<CommonResponse>{
        try{
            return await this.service.getIgstData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getIGSTAmountReport')
    async getIGSTAmountReport(@Body() req:IgstReportReq):Promise<CommonResponse>{
        try{
            return await this.service.getIGSTAmountReport(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getIGSTAgingReport')
    async getIGSTAgingReport(@Body() req:IgstReportReq):Promise<CommonResponse>{
        try{
            return await this.service.getIGSTAgingReport(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getRMInvoiceWiseData')
    async  getRMInvoiceWiseData(@Body() req:AgingReq):Promise<CommonResponse>{
        try{
            return await this.service.getRMInvoiceWiseData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getPMInvoiceWiseData')
    async  getPMInvoiceWiseData(@Body() req:AgingReq):Promise<CommonResponse>{
        try{
            return await this.service.getPMInvoiceWiseData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getVendorPackTaxData')
    async  getVendorPackTaxData(@Body() req:IgstReportReq):Promise<CommonResponse>{
        try{
            return await this.service.getVendorPackTaxData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getVendorRMTaxData')
    async  getVendorRMTaxData(@Body() req:IgstReportReq):Promise<CommonResponse>{
        try{
            return await this.service.getVendorRMTaxData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getRmSuppliers')
    async getRmSuppliers():Promise<CommonResponse>{
        try{
            return await this.service.getRmSuppliers();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getPackingVendors')
    async getPackingVendors(@Body() req?:PayableFilterRequest):Promise<CommonResponse>{
        console.log(req,'iiiiiiiiiii');
        
        try{
            return await this.service.getPackingVendors(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getRmInvoices')
    async getRmInvoices():Promise<CommonResponse>{
        try{
            return await this.service.getRmInvoices();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getPackingInvoices')
    async getPackingInvoices(@Body() req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            return await this.service.getPackingInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getPackingPayables')
    @ApiBody({
  schema: {
    type: 'array',
    items: { type: 'number' },
  },
})
async getPackingPayables(@Body() req: PayableFilterRequest):Promise<CommonResponse>{
        try{
            console.log(req,'controlllllllllll');
            
            return await this.service.getPackingPayables(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getRmPayables')
    async getRmPayables(@Body() req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            return await this.service.getRmPayables(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
 @Post('/savePayables')
    async savePayables(@Body() req:PayableRequest):Promise<CommonResponse>{
        try{
            return await this.service.savePayables(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getPayablesForPacking')
    async getPayablesForPacking(@Body() req:PayableFilterRequest):Promise<CommonResponse>{
        console.log("!!!!!!!!!!!!!")
        try{
            return await this.service.getPayablesForPacking(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getPayablesForRM')
    async getPayablesForRM(@Body() req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            return await this.service.getPayablesForRM(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
  @Post('/getPayablesSuppliers')
    async getPayablesSuppliers(@Body() req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            return await this.service.getPayablesSuppliers(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
      @Post('/getPayablesInvoices')
    async getPayablesInvoices(@Body() req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            return await this.service.getPayablesInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getOverDueReceivables')
    async getOverDueReceivables(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getOverDueReceivables(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getOverDueReceivablesRanges')
    async getOverDueReceivablesRanges(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getOverDueReceivablesRanges(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getTotalIncentiveAmount')
    async getTotalIncentiveAmount(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalIncentiveAmount(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getTotalReceivedIncentiveAmount')
    async getTotalReceivedIncentiveAmount(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalReceivedIncentiveAmount(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getTotalOverDueIncentiveAmount')
    async getTotalOverDueIncentiveAmount(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalOverDueIncentiveAmount(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getTotalRodtepDueIncentive')
    async getTotalRodtepDueIncentive(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalRodtepDueIncentive(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    } 
    @Post('/getTotalDdbDueIncentive')
    async getTotalDdbDueIncentive(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalDdbDueIncentive(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    } 
    @Post('/getTotalIgstDueIncentive')
    async getTotalIgstDueIncentive(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalIgstDueIncentive(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getRodtepDueRanges')
    async getRodtepDueRanges(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getRodtepDueRanges(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    } 
    @Post('/getDdbDueRanges')
    async getDdbDueRanges(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getDdbDueRanges(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    } 
    @Post('/getIgstDueRangess')
    async getIgstDueRangess(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getIgstDueRangess(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    } 
    @Post('/getDdbDueInvoices')
    async getDdbDueInvoices(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getDdbDueInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getIgstDueInvoices')
    async getIgstDueInvoices(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getIgstDueInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getRodtepDueInvoices')
    async getRodtepDueInvoices(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getRodtepDueInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getTotalReciveableInvoices')
    async getTotalReciveableInvoices(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getTotalReciveableInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getOverDueReceivablesinvoices')
    async getOverDueReceivablesinvoices(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getOverDueReceivablesinvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getRMDueAmountData')
    async getRMDueAmountData(@Body() req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getRMDueAmountData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getRmPaidAmountData')
    async getRmPaidAmountData(@Body() req:RmDateReq):Promise<CommonResponse>{
        try{
            return await this.service.getRmPaidAmountData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getRmagingDuesData')
    async getRmagingDuesData(@Body() req?:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            return await this.service.getRmagingDuesData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getSalesInvoiceAmount')
    async getSalesInvoiceAmount():Promise<CommonResponse>{
        try{
            return await this.service.getSalesInvoiceAmount();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getSalesNetWeight')
    async getSalesNetWeight():Promise<CommonResponse>{
        try{
            return await this.service.getSalesNetWeight();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getContainerShippedSoCount')
    async getContainerShippedSoCount(@Body() req:RmDateReq):Promise<CommonResponse>{
        try{
            return await this.service.getContainerShippedSoCount(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
        @Post('/rmDueData')
    async rmDueData(@Body() req:RmDateReq):Promise<CommonResponse>{
        console.log(req,"req controller")
        try{
            return await this.service.rmDueData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getCompanysForCeoDashboard')
    async getCompanysForCeoDashboard():Promise<CommonResponse>{
        try{
            return await this.service.getCompanysForCeoDashboard();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
         @Post('/getPackingPayableInvoices')
    @ApiBody({
  schema: {
    type: 'array',
    items: { type: 'number' },
  },
})
async getPackingPayableInvoices(@Body() req?: PayableFilterRequest):Promise<CommonResponse>{
        try{
            console.log(req,'controlllllllllll');
            
            return await this.service.getPackingPayableInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getRmPayableInvoices')
    async getRmPayableInvoices(@Body() req?:PayableFilterRequest):Promise<CommonResponse>{
        try{
            return await this.service.getRmPayableInvoices(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getVendorRMTaxDataReport')
    async getVendorRMTaxDataReport(@Body() req?:AgingReq):Promise<CommonResponse>{
        try{
            return await this.service.getVendorRMTaxDataReport(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
     @Post('/getVendorPackTaxDataReport')
    async getVendorPackTaxDataReport(@Body() req?:AgingReq):Promise<CommonResponse>{
        try{
            return await this.service.getVendorPackTaxDataReport(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

          @Post('/getRmInvoiceDataForPayables')
  async getRmInvoiceDataForPayables(@Body() req?: RmPayblesReq): Promise<CommonResponse>  {
      try {
          return await this.service.getRmInvoiceDataForPayables(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
          @Post('/getRmInvoiceDataForView')
  async getRmInvoiceDataForView(@Body() req?:any): Promise<CommonResponse>  {
      try {
          return await this.service.getRmInvoiceDataForView(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

 }

